import { Period, PeriodUnit } from 'components/CustomRepeatEvery/CustomRepeatEvery';
import { PAYMENT_METHODS } from 'views/PrepaidLoyalty/commons/constants';
import moment from 'moment';
import { ISelectedPackage } from 'views/PrepaidLoyalty/AddNewServices';

export const validatePaymentMethodStep = (
	paymentMethod: number,
	masterNumber: string,
	creditCardData: types.topUpAddOns.IFormData
): boolean => {
	if (paymentMethod === PAYMENT_METHODS.BY_MASTER_NUMBER) {
		return masterNumber.length > 3;
	} else if (paymentMethod === PAYMENT_METHODS.BY_CREDIT_CARD) {
		if (creditCardData.type === 'token') {
			return !!creditCardData.tokenId;
		}
		return (
			creditCardData.number.length === 16 &&
			creditCardData.holder.length > 3 &&
			creditCardData.date.length === 4 &&
			creditCardData.cvv.length === 3
		);
	}
	return false;
};

export const validateNumbersTopup = (
	selectedNumbers: types.topUpAddOns.INumber[],
	creditLimit: string,
	totalAmount: number,
	paymentMethod: number
): boolean => {
	if (paymentMethod === PAYMENT_METHODS.BY_MASTER_NUMBER) {
		return selectedNumbers.length > 0 && Number(creditLimit) >= totalAmount;
	} else if (paymentMethod === PAYMENT_METHODS.BY_CREDIT_CARD) {
		return selectedNumbers.length > 0;
	}
	return false;
};

export const validateServices = (
	selectedPackages: ISelectedPackage[],
	creditLimit: string,
	totalAmount: number,
	paymentMethod: number
): boolean => {
	if (paymentMethod === PAYMENT_METHODS.BY_MASTER_NUMBER) {
		return selectedPackages.length > 0 && Number(creditLimit) >= totalAmount;
	} else if (paymentMethod === PAYMENT_METHODS.BY_CREDIT_CARD) {
		return selectedPackages.length > 0;
	}
	return false;
};

export const validateDateStep = (
	period: Period,
	isRepeatEnabled: boolean,
	periodicity: string,
	selectedPeriod: PeriodUnit,
	repeatPeriod?: string
): boolean => {
	const allowedPeriods = [PeriodUnit.DAY, PeriodUnit.WEEK, PeriodUnit.MONTH];
	const startDateCorrect =
		period.startDate instanceof moment && period.startDate.isSameOrAfter(moment().startOf('day'));
	if (isRepeatEnabled) {
		const endDateCorrect =
			period.endDate instanceof moment && period.endDate.isSameOrAfter(moment().startOf('day'));
		const isDataValid =
			startDateCorrect &&
			endDateCorrect &&
			Number(periodicity) > 0 &&
			allowedPeriods.indexOf(selectedPeriod) !== -1;
		if (repeatPeriod) {
			
			return isDataValid && Number(repeatPeriod) > 0;
		}
		return isDataValid;
	}
	return startDateCorrect;
};

export const validateDonationStep = (
	showDonations: boolean,
	selectedDonation: types.topUpAddOns.IDonation | undefined
) => {
	return !showDonations || (!!selectedDonation && selectedDonation.value > 0);
};
